import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmsServicesService {

  constructor(private api : ApiService,private http: HttpClient) { 
  }

  getUsers(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}auth-service/auth/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 
  
  getRoleMappingList(){
    const url = `${environment.New_BASE_DOMAIN}auth-service/role/getRoleMappingList?platform=ems`;
    return this.api.get(url);
  } 

  addVendorAndEmployee(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'auth-service/auth/createUser')
    return this.api.post(url,formData);
  }
  updateUser(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'auth-service/auth/updateUser')
    return this.api.put(url,formData);
  }
  createAccount(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'account-service/config/createAccount')
    return this.api.post(url,formData);
  }
  updateAccount(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'account-service/config/updateAccount')
    return this.api.put(url,formData);
  }
  
  
  getAccounts(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/info/getAccounts?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }
  
  getAccountMappings(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/info/getAccountMappings?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }

  addOrUpdateAccountMapping(formData:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/config/addOrUpdateAccountMapping`;
    return this.api.post(url,formData);
  }

quickCodeCategory(){
  const url = (environment.New_BASE_DOMAIN + '/ems-service/master/getAllMasterCategory')
  return this.api.get(url);
}

quickCodeList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/master/getQuickCodes?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

addQuickCode(formData:any){
    const url = (environment.New_BASE_DOMAIN + '/ems-service/master/addOrUpdateQuickCode')
    return this.api.post(url,formData);
}

employeesList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/employee/getEmployees?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
addMasterEmployee(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ems-service/employee/addOrUpdate')
  return this.api.post(url,formData);
}
getQuickCodeListByCategoryId(ids:any){
  let url = `${environment.New_BASE_DOMAIN}ems-service/master/getQuickCodeListByCategoryId`
  if (ids) {
    url += `?categoryId=${ids}`;
  }
  return this.api.get(url);
}
expenseAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ems-service/expense/addOrUpdate')
  return this.api.post(url,formData);
}
getExpenseList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/expense/getExpenses?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
deleteExpense(id:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/expense/deleteExpenses?id=${id}`
  return this.api.delete(url);
}


getWarehouseList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}warehouse-service/info/getWarehouseByFilter?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

createWarehouse(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'warehouse-service/config/createWarehouse')
  return this.api.post(url,formData);
}
updateWarehouse(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'warehouse-service/config/updateWarehouse')
  return this.api.put(url,formData);
}
getWarehouseByFilter(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}warehouse-service/info/getWarehouseByFilter?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

upload(file: File): Observable<HttpEvent<any>> {
  var url :any
  const formData: FormData = new FormData();
  formData.append('file', file);
  const headers = new HttpHeaders({
    'VER': '1',
    'DEVICE-TYPE':'Web'
  });
  // headers.append('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  url = `${environment.New_BASE_DOMAIN}utils-service/uploads/uploadFiles`;

  const req = new HttpRequest('POST', url, formData, {
    headers,
    reportProgress: true,
    responseType: 'json'
  });
  return this.http.request(req);
}

approvalAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ems-service/approval/addOrUpdate')
  return this.api.post(url,formData);
}
getApprovalMatrices(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/approval/getApprovalMatrices?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
deleteApprovalMatrices(id:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/approvalMatrices/deleteApprovalMatrices?id=${id}`
  return this.api.delete(url);
}
bulkApprovalMatrices(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ems-service/approval/addOrUpdate')
  return this.api.post(url,formData);
}

getRevenueAttributes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/revenue/getRevenueAttributes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
bulkAddOrUpdateAttribute(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/revenue/bulkAddOrUpdateAttribute')
  return this.api.post(url,formData);
}

getExpenseAttributes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/expense/getExpenseAttributes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
expensesBulkAddOrUpdateAttribute(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/expense/bulkAddOrUpdateAttribute')
  return this.api.post(url,formData);
}
isInvoiceNumberExist(invoiceNumber:any,vendorId:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/invoice/isInvoiceNumberExist?invoiceNumber=${invoiceNumber}&vendorId=${vendorId}`;
  return this.api.get(url);
} 

getPeoplePointEmployeeDetails(userName:any){
  const url = `${environment.New_BASE_DOMAIN}auth-service/auth/getPeoplePointEmployeeDetails?employeeCode=${userName}`;
  return this.api.get(url);
}
validateEmployee(userName:any){
  const url = `${environment.New_BASE_DOMAIN}auth-service/auth/isUserCodeExist?userName=${userName}`;
  return this.api.get(url);
}
getCostCenter(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/costCenter/getCostCenter?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
costCenterAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/costCenter/addOrUpdate')
  return this.api.post(url,formData);
}
bulkUpdateInvoiceLineItem(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/invoice/bulkUpdateInvoiceLineItem')
  return this.api.post(url,formData);
}

getConsolidatedInvoiceLineItem(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/invoice/getConsolidatedInvoiceLineItem')
  return this.api.post(url,formData);
}
getExpenseById(id:any){
  const url = (environment.New_BASE_DOMAIN + `ems-service/expense/getExpenseById?expenseId=${id}`)
  return this.api.post(url,[]);
}

expenseSubCategoryInvoiceExist(mappingId:any,vendorId:any,expenseId:any,expenseSubCategoryId:any,financialYearId:any,invoiceMonth:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/invoice/isExpenseSubCategoryInvoiceExist?mappingId=${mappingId}&vendorId=${vendorId}
  &expenseId=${expenseId}&expenseSubCategoryId=${expenseSubCategoryId}&financialYearId=${financialYearId}
  &invoiceMonth=${invoiceMonth}`;
  return this.api.get(url);
}
}
